exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".iN9rKzGmRt9dux_NGV9g9{display:inline-block;vertical-align:middle;width:1em;height:1em}._1D7DGBOTCm67GdNynlQmcl{height:100%;fill:currentColor;vertical-align:top}", ""]);
// Exports
exports.locals = {
	"root": "iN9rKzGmRt9dux_NGV9g9",
	"svg": "_1D7DGBOTCm67GdNynlQmcl"
};